import { z } from 'zod/v4'

export const brandValidation = () => {
  return z.object({
    name: z.string().min(1, { message: 'Form is required' }),
    slug: z.string().min(1, { message: 'Form is required' }),
    country_id: z.string({ message: 'Form is required' }).min(1, { message: 'Form is required' }),
    website: z.string().url('invalid URL Format').optional().or(z.literal('')).nullable(),
    description: z.string().min(1, { message: 'Form is required' }),
    active: z.coerce.boolean(),
    priority: z.coerce.number().min(1, { message: 'Form is required' }).nonnegative({ message: 'Priority must be at least 0' }),
    is_import: z.boolean(),
    is_partnered: z.boolean(),
    featured: z.boolean(),
    principal_brand: z.boolean(),
    open_distributor_country: z.array(z.string()).optional(),
    user_id: z.string().nullable(),
    main_supplier_id: z.string().nullable(),
    sub_supplier_id: z.array(z.string()).optional(),
    export_minimum_value: z.coerce.number().optional().nullable(),
    export_currency: z.string().optional().nullable(),
  }).refine(
    (data) => {
      if (data.principal_brand) {
        return data.open_distributor_country.length > 0
      }
      return true
    }, {
      message: 'Please select at least one country',
      path: ['open_distributor_country'],
    }
  )
}